export const HISTORY_GROUP_KEYS = ["today", "yesterday", "last7Days", "older"];

const DAY_MS = 24 * 60 * 60 * 1000;

function startOfLocalDay(time) {
    const date = new Date(time);
    date.setHours(0, 0, 0, 0);
    return date.getTime();
}

export function getHistoryGroupKey(updatedAt, now = Date.now()) {
    const today = startOfLocalDay(now);
    if (updatedAt >= today) return "today";
    if (updatedAt >= today - DAY_MS) return "yesterday";
    if (updatedAt >= today - 7 * DAY_MS) return "last7Days";
    return "older";
}

/**
 * Group chats (newest first) into Today / Yesterday / Last 7 days / Older,
 * optionally filtered by a title search. Empty groups are omitted.
 * @param {Array<{ id: string, title: string, updatedAt: number }>} chats
 * @param {{ now?: number, query?: string }} [options]
 * @returns {Array<{ key: string, chats: Array }>}
 */
export function groupChatsByDate(chats, { now = Date.now(), query = "" } = {}) {
    const needle = query.trim().toLowerCase();
    const sorted = [...(chats ?? [])]
        .filter((chat) => !needle || (chat.title ?? "").toLowerCase().includes(needle))
        .sort((a, b) => (b.updatedAt ?? 0) - (a.updatedAt ?? 0));

    const buckets = new Map(HISTORY_GROUP_KEYS.map((key) => [key, []]));
    for (const chat of sorted) {
        buckets.get(getHistoryGroupKey(chat.updatedAt ?? 0, now)).push(chat);
    }
    return HISTORY_GROUP_KEYS
        .map((key) => ({ key, chats: buckets.get(key) }))
        .filter((group) => group.chats.length > 0);
}

/** A chat title generated from the first prompt. */
export function titleFromPrompt(prompt, maxLength = 60) {
    const text = String(prompt ?? "").replace(/\s+/g, " ").trim();
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength - 1).trimEnd() + "…";
}
